import { render, staticRenderFns } from "./PanelBlueLabelPlayerDescription.vue?vue&type=template&id=287cdad5&scoped=true&"
import script from "./PanelBlueLabelPlayerDescription.vue?vue&type=script&lang=js&"
export * from "./PanelBlueLabelPlayerDescription.vue?vue&type=script&lang=js&"
import style0 from "./PanelBlueLabelPlayerDescription.vue?vue&type=style&index=0&id=287cdad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287cdad5",
  null
  
)

export default component.exports